import HWUser from "../HWLibrary/HWUser";

import { s360ConfigService } from "./S360Config";

const watchForChatSDKEvents = (appComponent) => {
  window.addEventListener(
    "message",
    (messageEvent) => {
      if (
        !s360ConfigService.isClientHostConfigured() ||
        messageEvent.origin !== s360ConfigService.sourceOrigin
      ) {
        // return;
        //preventing return for godaddy error
      }

      try {
        let messageData = JSON.parse(messageEvent.data);

        switch (messageData.action) {
          case "on-update-dynamic-form":
            appComponent.setShowDynamicForm((prev) => !prev);
            s360ConfigService.showDynamicForm(messageData.data);
            break;
          case "on-set-user-config":
            s360ConfigService.setUserConfig(JSON.stringify(messageData.data));
            appComponent.setUser(JSON.stringify(messageData.data));
            break;
          case "on-update-user-metadata":
            s360ConfigService.sendUserData(messageData.data);
            break;
          case "on-config-data-update":
            //STEP 6
            s360ConfigService.setConfig(messageData.data);
            appComponent.setRefresh((currentRefresh) => !currentRefresh);
            break;
          case "on-deferred-brand-icon":
            // Large brand icons are stripped from the boot URL hash and sent
            // separately via postMessage to avoid browser URL length limits.
            if (messageData.data?.brandIcon) {
              const currentConfig = s360ConfigService.getConfig();
              if (currentConfig?.configDetails) {
                currentConfig.configDetails.brandIcon =
                  messageData.data.brandIcon;
                s360ConfigService.setConfig(currentConfig);
                appComponent.setRefresh((currentRefresh) => !currentRefresh);
              }
            }
            break;
          case "on-reset-user":
            onResetUser();
            break;
          case "chat-maximize":
            appComponent.setChatMaximized(true);
            break;
          case "chat-minimize":
            appComponent.setChatMaximized(false);
            break;
          case "show-network-reload-popup":
            // Trigger mobile network reload popup
            triggerMobileNetworkReload(messageData.data);
            break;
          default:
            break;
        }
      } catch (error) {}
    },
    false,
  );
};

const onResetUser = () => {
  HWUser.resetUser();
  window.location.reload();
};

const triggerMobileNetworkReload = (data) => {
  // Create a custom event to trigger the mobile network reload popup
  const event = new CustomEvent("mobileNetworkReload", {
    detail: { autoReload: data?.autoReload || true },
  });
  window.dispatchEvent(event);
};

const postPlatformMessage = (messageData, actionName) => {
  // STEP 3
  let message = {
    data: messageData,
    action: actionName,
    clientHostId: s360ConfigService.clientHostId,
  };
  try {
    window.parent.postMessage(JSON.stringify(message), "*");
  } catch (error) {}
};

const fetchConfigDetailsFromClientHost = () => {
  // STEP 2
  postPlatformMessage(null, "update-client-host-config");
};
const checkChangeInConfig = () => {
  postPlatformMessage(null, "check-config-diffrence");
};
const loadLocalUser = () => {
  postPlatformMessage(null, "load-local-user");
};
const sendOnAppOpen = () => {
  postPlatformMessage(null, "on-app-open");
};

const sendOnAppClose = () => {
  postPlatformMessage(null, "on-app-close");
};

const requestNotification = () => {
  postPlatformMessage(null, "request-notification");
};

const sendNotification = (notificationMessage) => {
  if (!s360ConfigService?.config?.sandbox) {
    postPlatformMessage(notificationMessage, "notification");
  }
};

export {
  checkChangeInConfig,
  fetchConfigDetailsFromClientHost,
  loadLocalUser,
  requestNotification,
  sendNotification,
  sendOnAppClose,
  sendOnAppOpen,
  triggerMobileNetworkReload,
  watchForChatSDKEvents,
};
